<template>
    <article class="cmp cmp-product-thumb" :data-testing="item.variation.id">
        <div :class="paddingClasses" :style="paddingInlineStyles">
            <div class="thumb-image">
                <div class="prop-1-1">
                    <slot name="item-image">
                        <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                                 :alt="item | itemName"
                                                 :title="item | itemName"
                                                 :item-url="item | itemURL(urlWithVariationId)"
                                                 :enable-carousel="$ceres.config.item.enableImageCarousel"
                                                 :disable-carousel-on-mobile="disableCarouselOnMobile"
                                                 ref="categoryImageCarousel">
                        </category-image-carousel>
                    </slot>
                </div>
            </div>


            <!-- ITEM DETAILS -->
            <slot name="item-details">
                <div class="thumb-content">
                    <a :href="item | itemURL(urlWithVariationId)" class="thumb-title small" :class="{ 'stretched-link': $ceres.config.global.shippingCostsCategoryId == 0 }">
                        {{ item | itemName }}<!--
                    --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
                    </a>
                    <div class="thumb-meta mt-2">
                        <slot name="before-prices"></slot>

                        <div class="prices justify-content-center">
                            <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.unitPrice.value" class="price-view-port">
                                <del class="crossprice" v-if="item.prices.specialOffer">
                                    {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                                </del>
                                <del class="crossprice" v-else>
                                    {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                                </del>
                            </div>

                          <template v-if="showme != undefined">
                            <div class="price">
                              <template v-if="item.item.itemType === 'set'">
                                ab {{ $translate("Ceres::Template.itemSetPrice", { price: showme.price.formatted }) }}
                              </template>
                              <template v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting" >
                                ab {{ $translate("Ceres::Template.categoryItemFromPrice", { price: showme.price.formatted }) }}
                              </template>
                              <template v-else>
                                ab {{ showme.price.value | currency }}
                              </template>
                            </div>
                          </template>
                          <template v-else>
                            <div class="price">
                              <template v-if="item.item.itemType === 'set'">
                                 {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }}
                              </template>
                              <template v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting" >
                                 {{ $translate("Ceres::Template.categoryItemFromPrice", { price: itemPrice }) }}
                              </template>
                              <template v-else>
                                 {{ item.prices.default.unitPrice.value | currency }}
                              </template>
                            </div>
                          </template>
                        </div>
                        <div class="base-price text-muted" v-html="item.prices.default.basePrice"></div>
                    </div>

                    <slot name="after-prices"></slot>

                </div>
            </slot>
            <!-- ./ITEM DETAILS  -->
        </div>
    </article>
</template>

<script>
    import { mapState } from "vuex";
    import CategoryImageCarousel from "../components/itemList/CategoryImageCarousel.vue";
    import ItemStoreSpecial from "../components/itemList/ItemStoreSpecial.vue";

    export default {
        components: {
            CategoryImageCarousel,
            ItemStoreSpecial
        },

        props: {
            decimalCount:
                {
                    type: Number,
                    default: 0
                },
            imageUrlAccessor:
                {
                    type: String,
                    default: "urlMiddle"
                },
            itemData:
                {
                    type: Object
                },
            disableCarouselOnMobile:
                {
                    type: Boolean
                },
            paddingClasses:
                {
                    type: String,
                    default: null
                },
            paddingInlineStyles:
                {
                    type: String,
                    default: null
                },
            forceUrlWithVariationId:
                {
                    type: Boolean,
                    default: false
                }
        },

        jsonDataFields: [
            "itemDataRef"
        ],

        computed:
            {
                showme()
                {
                  const currentVariation = this.item;

                  let prices = currentVariation && currentVariation.prices.graduatedPrices;
                  const minQuantity = currentVariation && currentVariation.variation.minimumOrderQuantity;

                  prices = prices.filter(price => price.minimumOrderQuantity > minQuantity);

                  return [...prices].sort((priceA, priceB) =>
                  {
                    return priceA.price.value - priceB.price.value;
                  })[0] ?? undefined;
                },
                item()
                {
                    return this.itemData || this.itemDataRef;
                },

                /**
                 * returns itemData.item.storeSpecial
                 */
                storeSpecial()
                {
                    return this.item.item.storeSpecial;
                },

                /**
                 * returns itemData.texts
                 */
                texts()
                {
                    return this.item.texts;
                },

                itemPrice()
                {
                    return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
                },

                itemSetPrice()
                {
                    return this.$options.filters.currency(
                        this.item.prices.default.price.value,
                        this.item.prices.default.currency
                    );
                },

                urlWithVariationId()
                {
                    return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
                },

                ...mapState({
                    showNetPrices: state => state.basket.showNetPrices
                })
            }
    }
</script>
